module.exports = __webpack_public_path__ + "assets/img/dahuojian-2d21c548.png";